import { AppModule } from 'app/module';
import 'module/previewLogo/main';
import Template from './template.hbs';
import './styles.scss';

export class PreviewHeader extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            sizeSwitches: ['.m-previewHeader__switchGroup .m-previewHeader__sizeSwitch'],
            pageSwitches: ['.m-previewHeader__switchGroup .m-previewHeader__pageSwitch'],
            activeSizeSwitch: '.m-previewHeader__sizeSwitch--active',
            activePageSwitch: '.m-previewHeader__pageSwitch--active',
        };
    }

    domEvents() {
        for (let i = 0; i < this.dom.sizeSwitches.length; i += 1) {
            this.dom.sizeSwitches[i].addEventListener('click', (e) => this.switchSize(e));
        }
        for (let i = 0; i < this.dom.pageSwitches.length; i += 1) {
            this.dom.pageSwitches[i].addEventListener('click', (e) => this.switchPage(e));
        }
    }

    getPropsFromDom() {
        const activeMenuItemSize = {};
        const activeMenuItemPage = {};
        const iFrameSrc = {};

        for (let i = 0; i < this.dom.sizeSwitches.length; i += 1) {
            const size = this.dom.sizeSwitches[i].getAttribute('data-size');
            activeMenuItemSize[size] = this.dom.sizeSwitches[i].classList.contains(
                'm-previewHeader__sizeSwitch--active',
            );
        }

        for (let i = 0; i < this.dom.pageSwitches.length; i += 1) {
            const page = this.dom.pageSwitches[i].getAttribute('data-page');
            activeMenuItemPage[page] = this.dom.pageSwitches[i].classList.contains(
                'm-previewHeader__pageSwitch--active',
            );
            iFrameSrc[page] = this.dom.pageSwitches[i].getAttribute('data-src');
        }

        return {
            activeMenuItemSize,
            activeMenuItemPage,
            iFrameSrc,
            isAgpPdl: this.dom.el.getAttribute('data-is-agp-pdl') === 'true',
        };
    }

    switchPage(e) {
        const target = e.currentTarget;
        const clickedPageSwitch = target.getAttribute('data-page');
        const activePageSwitch = this.dom.activePageSwitch.getAttribute('data-page');
        const clickedPageSwitchSrc = target.getAttribute('data-src');
        this.events.emit('changeSrc', clickedPageSwitchSrc);
        if (clickedPageSwitch !== activePageSwitch) {
            this.updateProps({ activeMenuItemPage: { [clickedPageSwitch]: true, [activePageSwitch]: false } }, true);
        }
    }

    switchSize(e) {
        const target = e.currentTarget;
        const clickedSizeSwitch = target.getAttribute('data-size');
        const activeSizeSwitch = this.dom.activeSizeSwitch.getAttribute('data-size');
        this.events.emit('changeSize', clickedSizeSwitch);
        if (clickedSizeSwitch !== activeSizeSwitch) {
            this.updateProps({ activeMenuItemSize: { [clickedSizeSwitch]: true, [activeSizeSwitch]: false } }, true);
        }
    }
}
